import { useRef } from "react";
import { styled } from "../../../../lib/styled";
import { useOnScrollIntoView } from "../../../../hooks/useOnScrollIntoView";

// How far before the strip reaches the viewport the next page is asked for.
const LOOK_AHEAD = "300px";

interface InfiniteScrollSentinelProps {
  /** Called each time the sentinel scrolls into view (or near it). */
  onReach: () => void;
  /** While true, the sentinel does not fire, e.g. while a page is loading or at the end. */
  disabled?: boolean;
}

// An empty strip at the end of a list; it takes no room of its own.
const Strip = styled("div")({ height: 1, width: "100%" });

/**
 * Marks the end of a list that loads more as the reader scrolls. Place it after the last item and
 * pass `onReach`; it fires when the strip comes within 300px of the viewport.
 */
export function InfiniteScrollSentinel({ onReach, disabled = false }: InfiniteScrollSentinelProps) {
  const strip = useRef<HTMLDivElement>(null);
  useOnScrollIntoView(strip, onReach, { disabled, rootMargin: LOOK_AHEAD });
  return <Strip ref={strip} aria-hidden="true" />;
}
